// =============================================================================
// SurveyType...
// =============================================================================
export interface QuestionTypesType {
  id: string;
  value: string;
}
export const emptyQuestionTypes = [];
